import { useEffect } from 'react';
import { useStreamStore } from './stream';

/**
 * Keeps live quotes coming for these symbols while the caller is mounted (subscriptions are counted, so this never
 * cancels one that Market Watch or a chart still needs).
 */
export function useQuoteSubscription(symbols: readonly string[]): void {
  const store = useStreamStore();
  const key = [...new Set(symbols)].sort().join(',');
  useEffect(() => {
    const list = key === '' ? [] : key.split(',');
    if (list.length === 0) return;
    void store.subscribeQuotes(list);
    return () => void store.unsubscribeQuotes(list);
  }, [store, key]);
}
